import { Component, ElementRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { VisibaSvgIconRepository } from './visibaSvgIconRepository';

@Component({
	standalone: false,
	selector: 'visiba-svg',
	template: /*language=html*/ `
		<svg
			[innerHtml]="icon.html | safeHtml"
			[attr.viewBox]="icon.viewBox"
			[attr.style]="icon.style"
			[attr.class]="'svg_' + alias"
		></svg>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisibaSvg {
	@Input('a') alias: string;
	@Input('color') color: string = null;
	icon = null;

	constructor(
		private _elementRef: ElementRef,
		private _svgIconRepository: VisibaSvgIconRepository,
	) {}

	ngOnInit() {
		this.icon = this._svgIconRepository.get(this.alias);
	}

	ngAfterViewInit() {
		if (this.color !== null) {
			const childrenFill = this._elementRef.nativeElement.querySelectorAll('.fill');
			for (let i = 0; i < childrenFill.length; i++) childrenFill[i].style.fill = this.color;

			const childrenStroke = this._elementRef.nativeElement.querySelectorAll('.stroke');
			for (let i = 0; i < childrenStroke.length; i++) childrenStroke[i].style.stroke = this.color;
		}
	}
}
